var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllipsis(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120.5 20.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13,.5c1.62.96,3.52,1.63,4.82,2.92,4.54,4.51,3.39,12.98-2.33,15.82-5,2.48-12.64,1.29-14.44-5.87-.12-.47-.37-.91-.55-1.36,0-1.17,0-2.33,0-3.5C1.83,4.49,4.33,1.66,8.5.5h4.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m120.5,13c-1.02,1.68-1.75,3.68-3.13,4.96-3.28,3.03-7.36,2.93-11.24,1.49-3.73-1.39-5.53-5.09-5.33-9.58.18-4.26,2.13-7.24,6.21-8.74.36-.13.66-.43.99-.64,1.67,0,3.33,0,5,0,3.66,1.34,6.33,3.67,7.5,7.5v5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m63,.5c1.42.81,3.01,1.42,4.23,2.46,3.34,2.85,3.99,6.67,2.86,10.68-1.12,3.98-3.97,6.2-8.14,6.6-.32.03-.64.17-.95.26-.5,0-1,0-1.5,0-7.54-2.09-10.69-7.87-7.93-14.41,1.32-3.14,4.1-4.38,6.93-5.59,1.5,0,3,0,4.5,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/ellipsis.d1ac8176f2542cb7d4107f845f401b67.svg";
export { ForwardRef as ReactComponent };